<div class="onboarding-wrapper dialog-wrapper">
  <button class="close-button" (click)="closePanel()">
    <mat-icon>close</mat-icon>
  </button>
  <form (ngSubmit)="postOnboard()" #onboardForm="ngForm">
    <div class="column">
      <custom-input
        [(ngModel)]="form.hotel_id"
        [name]="'hotel_id'"
        [required]="true"
        [type]="'number'"
        [label]="'Hotel id'"
      />
      <custom-input
        [(ngModel)]="form.hotel_name"
        [name]="'hotel_name'"
        [required]="true"
        [type]="'text'"
        [label]="'Hotel name'"
      />
      <!--  <custom-input
        [(ngModel)]="form.concluded_day"
        [name]="'concluded_day'"
        [required]="true"
        [type]="'text'"
        [label]="'Concluded day'"
      /> -->
      <custom-input
        [(ngModel)]="form.id_ntak"
        [name]="'id_ntak'"
        [required]="true"
        [type]="'text'"
        [label]="'Ntak id'"
      />
      <custom-input
        [(ngModel)]="form.tax_number"
        [name]="'tax_number'"
        [required]="true"
        [type]="'text'"
        [label]="'Tax number'"
      />
      <custom-input
        [(ngModel)]="form.company_name"
        [name]="'company_name'"
        [required]="true"
        [type]="'text'"
        [label]="'Company name'"
      />
      <custom-input
        [(ngModel)]="form.tax_primary"
        [name]="'tax_primary'"
        [required]="true"
        [label]="'Tax primary'"
        [type]="'number'"
      />
      <custom-select
        [(ngModel)]="form.primary_currency"
        [name]="'primary_currency'"
        [required]="true"
        [label]="'primary_currency'"
        [options]="currencyOptions"
      />
      <custom-input
        [(ngModel)]="form.tax_secondary"
        [name]="'tax_secondary'"
        [required]="true"
        [label]="'Tax secondary'"
        [type]="'number'"
      />
      <custom-select
        [(ngModel)]="form.secondary_currency"
        [name]="'secondary_currency'"
        [required]="true"
        [label]="'secondary_currency'"
        [options]="currencyOptions"
      />

      <custom-input
        [(ngModel)]="form.email"
        [name]="'email'"
        [required]="true"
        [type]="'email'"
        [label]="'Email'"
      />
      <custom-input
        [(ngModel)]="form.city"
        [name]="'city'"
        [required]="true"
        [type]="'text'"
        [label]="'City'"
      />
      <custom-input
        [(ngModel)]="form.postcode"
        [name]="'postcode'"
        [required]="true"
        [type]="'text'"
        [label]="'Postcode'"
      />
      <custom-input
        [(ngModel)]="form.address"
        [name]="'address'"
        [required]="true"
        [type]="'text'"
        [label]="'Address'"
      />
      <custom-input
        [(ngModel)]="form.net_price"
        [name]="'net_price'"
        [required]="true"
        [type]="'number'"
        [label]="'Net price'"
      />
      <custom-select
        [(ngModel)]="form.currency"
        [name]="'currency'"
        [required]="true"
        [label]="'Currency'"
        [options]="currencyOptions"
      />
      <custom-select
        [(ngModel)]="form.period"
        [name]="'period'"
        [required]="true"
        [label]="'Period'"
        [options]="periodOptions"
      />
      <custom-input
        [(ngModel)]="form.comment"
        [name]="'comment'"
        [required]="true"
        [type]="'text'"
        [label]="'Comment'"
      />
      <custom-checkbox
        [(ngModel)]="form.flat_tax"
        [name]="'flat_tax'"
        [required]="true"
        [label]="'Flat tax'"
      />
    </div>

    <div class="column">
      <custom-input
        [(ngModel)]="form.phone"
        [name]="'phone'"
        [required]="true"
        [type]="'text'"
        [label]="'Hotel phone'"
      />
      <custom-select
        [(ngModel)]="form.language"
        [name]="'language'"
        [required]="true"
        [label]="'Language'"
        [options]="langOptions"
      />
      <custom-input
        [(ngModel)]="form.contact_name"
        [name]="'contact_name'"
        [required]="true"
        [type]="'text'"
        [label]="'Contact name'"
      />

      <custom-select
        [(ngModel)]="form.country"
        [name]="'country'"
        [required]="true"
        [label]="'Country'"
        [options]="langOptions"
      />
      <custom-input
        [(ngModel)]="form.rooms"
        [name]="'rooms'"
        [required]="true"
        [type]="'number'"
        [label]="'Rooms'"
      />

      <custom-input
        [(ngModel)]="form.invoicing"
        [name]="'invoicing'"
        [required]="true"
        [type]="'number'"
        [label]="'Invoicing'"
      />
      <custom-checkbox
        [(ngModel)]="form.calendar_sync"
        [name]="'calendar_sync'"
        [required]="true"
        [label]="'Calendar sync'"
      />
      <custom-checkbox
        [(ngModel)]="form.channel_manager"
        [name]="'channel_manager'"
        [required]="true"
        [label]="'Channel manager'"
      />
      <custom-checkbox
        [(ngModel)]="form.vat_free"
        [name]="'vat_free'"
        [required]="true"
        [label]="'Vat free'"
      />
      <custom-checkbox
        [(ngModel)]="form.premium"
        [name]="'premium'"
        [required]="true"
        [label]="'Premium'"
      />
      <!-- <custom-input
        [(ngModel)]="form.username"
        [name]="'username'"
        [required]="true"
        [label]="'Username'"
      /> -->
    </div>
    <button
      class="secondary-button"
      type="submit"
      [disabled]="onboardForm.invalid"
    >
      Onboard
    </button>
  </form>
</div>
